var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIntegrate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.164 0 0 7.164 0 16c0 8.837 7.164 16 16 16 8.837 0 16-7.163 16-16 0-8.836-7.163-16-16-16z",
    fill: "#E6E9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 10.833h-13v2.333h13v-2.333zm-13-1.5H8v5.333h1.333v8h13.334v-8H24V9.333H9.5zm11.667 5.5H10.833v6.333h10.334v-6.333zm-7.834 2.583h5.334v-1.5h-5.334v1.5z",
    fill: "#7F8CFE"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDBDNy4xNjM1MiAwIDAgNy4xNjM1MiAwIDE2QzAgMjQuODM2NSA3LjE2MzUyIDMyIDE2IDMyQzI0LjgzNjUgMzIgMzIgMjQuODM2NSAzMiAxNkMzMiA3LjE2MzUyIDI0LjgzNjUgMCAxNiAwWiIgZmlsbD0iI0U2RTlGRiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIyLjUgMTAuODMzSDkuNVYxMy4xNjYzSDIyLjVWMTAuODMzWk05LjUgOS4zMzMwMUg4VjEwLjgzM1YxMy4xNjYzVjE0LjY2NjNIOS4zMzMzM1YxNC44MzNWMjEuMTY2M1YyMi42NjYzSDEwLjgzMzNIMjEuMTY2N0gyMi42NjY3VjIxLjE2NjNWMTQuODMzVjE0LjY2NjNIMjRWMTMuMTY2M1YxMC44MzNWOS4zMzMwMUgyMi41SDkuNVpNMjEuMTY2NyAxNC44MzNIMTAuODMzM1YyMS4xNjYzSDIxLjE2NjdWMTQuODMzWk0xMy4zMzMzIDE3LjQxNjNIMTguNjY2N1YxNS45MTYzSDEzLjMzMzNWMTcuNDE2M1oiIGZpbGw9IiM3RjhDRkUiLz4KPC9zdmc+Cg==";
export { SvgIntegrate as ReactComponent };